import { request } from '@umijs/max';

export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<{ success: boolean, data: API.LoginResult }>('/api/user/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function register(body: any, options?: { [key: string]: any }) {
  return request<{ success: boolean, data: API.RegisterResult }>('/api/user/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 刷新 Token 接口 (利用 HttpOnly Cookie) */
export async function refreshAccessToken() {
  return request<{ success: boolean, data: API.RefreshTokenResult }>('/api/user/refresh', {
    method: 'POST',
    credentials: 'include', // 必须发送 Cookie
    skipErrorHandler: true, // 报错由逻辑自己处理
  });
}

export async function queryCurrentUser(options?: { [key: string]: any }) {
  return request<{ success: boolean, data: API.CurrentUser }>('/api/user', {
    method: 'GET',
    ...(options || {}),
  });
}